import { useState } from 'react';
import DonateModal from './DonateModal';
import ExtensionModal from './ExtensionModal';

// Extension / support buttons shown under the card on the resource selection view.
function FooterLinks() {
  const [donateOpen, setDonateOpen] = useState(false);
  const [extensionOpen, setExtensionOpen] = useState(false);

  return (
    <div className="mt-4 md:mt-6 flex gap-2 md:gap-3">
        <button
            className="text-xs md:text-sm font-semibold px-4 md:px-5 py-1.5 md:py-2 rounded-full bg-primary/20 text-primary hover:bg-primary/30 hover:text-primary-light border border-primary/30 transition-all"
            onClick={() => setExtensionOpen(true)}>
            Get the extension
        </button>
        <button
            className="text-xs md:text-sm font-semibold px-4 md:px-5 py-1.5 md:py-2 rounded-full bg-accent/20 text-accent hover:bg-accent/30 hover:text-accent-hover border border-accent/30 transition-all"
            onClick={() => setDonateOpen(true)}>
            Support this tool
        </button>
        <ExtensionModal open={extensionOpen} onClose={() => setExtensionOpen(false)} />
        <DonateModal open={donateOpen} onClose={() => setDonateOpen(false)} />
    </div>
  );
}

export default FooterLinks;
